<template>
    <ion-page>
        <ion-header>
            <ion-toolbar color="custom-white">
                <ion-buttons slot="start">
                    <ion-button color="primary" @click="handleBackButton()">
                        <mdicon name="arrow-left"></mdicon>
                    </ion-button>
                </ion-buttons>

                <ion-title>
                    <span>Nieuwe visuele waarneming</span>
                </ion-title>

                <ion-buttons slot="end">
                    <ion-button color="primary" @click="confirm(true)">
                        <mdicon name="content-save"></mdicon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content color="light">
            <template v-if="!loading">

                <ion-list :inset="true">
                    <select-row v-if="!$store.getters.getInspectionId" label="Inspectie" v-model:value="observation.inspection_id" :items="inspections" field_name="name" field_value="id" />

                    <select-row-tree v-if="$store.getters.getInspectionId" :key="observation.inspection_id" :disabled="!observation.inspection_id" label="Bouwdeel" v-model:value="current_location_item_uuid" field_name="uuid" :inspection_id="observation.inspection_id" />

                    <SelectLocationItemComponent v-if="$store.getters.getInspectionId" :disabled="!current_location_item_uuid || disabled" :location_item_uuid="current_location_item_uuid" v-model:value="observation.location_item_component_uuid" />

                </ion-list>

                <image-array class="mt-3" :imageable_uuid="observation.uuid" :square="true" :disabled="!observation.location_item_component_uuid" ref="image-array"></image-array>

                <ion-list :inset="true">
                    <Remark @savePrivateRemark="savePrivateRemark" :disabled="!observation.location_item_component_uuid" label="Toelichting" v-model:value="observation.remark" field_name="name" :description_value="observation.remark_description" @updateDescription="observation.remark_description = $event" @autoClassify="setClassificationResult" />
                </ion-list>

                <transition name="fade">
                    <ClassificationComponent v-if="$store.getters.getInspectionMethodCode != 'CONF'" :model="observation" :classification_optional="true" @change="setClassificationResult" @isDefect="this.observation.is_defect = $event">
                    </ClassificationComponent>
                </transition>
            </template>

            <Loading v-if="loading" />

        </ion-content>
        <ion-footer class="ion-no-border">
            <ion-toolbar color="custom-white">
                <ion-buttons slot="start">
                    <ion-button color="medium" @click="handleBackButton()">
                        <mdicon class="icon" slot="start" name="close" />
                        Annuleren
                    </ion-button>
                </ion-buttons>
                <ion-buttons class="sm" slot="end">
                    <ion-button :disabled="saving" color="medium" @click="confirm(false)">
                        <mdicon class="icon" slot="start" name="content-save-outline" />
                        Concept
                    </ion-button>
                    <ion-button :disabled="saving" color="primary" @click="confirm(true)">
                        <mdicon class="icon" slot="start" name="content-save-check-outline" />
                        Voltooid
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-footer>

    </ion-page>
</template>

<script lang="js">
import ImageArray from '@/components/ImageArray.vue';
import {
    IonContent, IonIcon, IonHeader, modalController, alertController
} from '@ionic/vue';
import { add, list, albumsOutline, save, close, chevronBack, shieldCheckmark } from 'ionicons/icons';
import uuid from '../../plugins/uuid';
import { db } from '@/services/db'
import SelectRow from '@/components/SelectRow.vue';
import SelectRowTree from '@/components/SelectRowTree.vue';
import ComponentSelect from '../location_item_components/Create.vue';
import Remark from '../../components/Remark.vue';
import SelectLocationItemComponent from '@/components/SelectLocationItemComponent.vue';
import patch_post_parser from '@/services/patch_post_parser';
import ClassificationComponent from '@/components/ClassificationComponent.vue';
import convert from "@/services/convert";
import Loading from '@/components/Loading.vue';

export default {
    name: 'location-item-create',
    components: {
        IonContent,
        IonIcon,
        IonHeader,
        ImageArray,
        SelectRow,
        SelectRowTree,
        Remark,
        SelectLocationItemComponent,
        ClassificationComponent,
        Loading
    },
    data() {
        return {
            shieldCheckmark,
            add,
            list,
            albumsOutline,
            save,
            close,
            chevronBack,
            loading: true,
            saving: false,
            image_uuids: [],
            observation: {
                uuid: uuid(),
                remark: "",
                inspection_id: this.$store.getters.getInspectionId,
                location_item_component_id: null,
                location_item_component_uuid: null,
                danger_aspect_id: null,
                error_indication_id: null,
                error_classification_id: null,
                repair_period_id: null,
                is_defect: true,
            },
            danger_aspects: [],
            error_indications: [],
            error_classifications: [],
            repair_periods: [],
            remarks: [],
            location_item_components: [],
            location_item_component: {
                name: ""
            },
            location_items: [],
            inspections: [],
            current_location_item_uuid: null,
            hide_inspection_row: false,
            hide_location_item_row: false,
            hide_location_item_component_row: false,
        }
    },
    ionViewWillEnter() {
        this.setup()
    },
    ionViewWillLeave() {
        // Cleanup ImageArray component when page is cached
        if (this.$refs.imageArray) {
            if (this.$refs.imageArray.stopPolling) {
                this.$refs.imageArray.stopPolling();
            }

            // CRITICAL: Remove event listener that keeps component in memory
            if (this.$refs.imageArray.visibilityHandler) {
                document.removeEventListener('visibilitychange', this.$refs.imageArray.visibilityHandler);
            }

            // LazyImage components handle their own memory cleanup
            // Note: Don't clear images_array here - component will be properly destroyed on save/delete
        }
    },
    methods: {
        async handleBackButton() {
            // Delete any images that were added when canceling
            db.images.where({ imageable_uuid: this.observation.uuid }).toArray().then(images => {
                for (let image of images) {
                    db.images.delete(image.uuid);
                }
            });
            this.$router.back();
        },
        setClassificationResult(result) {
            if (!result) {
                return;
            }
            this.observation.classification = result;

            // for now we also set danger_aspect_id, error_indication_id, error_classification_id and repair_period_id separately
            // this is because the old way of setting the classification is still in use
            this.observation.danger_aspect_id = result?.danger_aspect_id;
            this.observation.error_indication_id = result?.error_indication_id;
            this.observation.error_classification_id = result?.error_classification_id;
            this.observation.repair_period_id = result?.repair_period_id;
        },
        savePrivateRemark(save) {
            this.observation.save_private_remark = save
        },
        addImage(image) {
            this.images.push(image)
        },
        setObservation(observation) {
            this.observation = observation
        },
        async createLocationItemComponent() {
            const modal = await modalController.create({
                component: ComponentSelect,
                initialBreakpoint: 1,
                breakpoints: [0.50, 1]
            });
            modal.present();

            const { data, role } = await modal.onWillDismiss();

            if (role == 'confirm') {
                let selected_component = data

                let location_item_component =
                {
                    location_item_id: this.observation.location_item_id,
                    location_item_uuid: this.observation.location_item_uuid,
                    inspection_id: this.observation.inspection_id,
                    uuid: uuid(),
                    component_id: selected_component.id,
                    component_uuid: selected_component.uuid,
                    name: selected_component.name,
                }

                let url = '/inspections/' + this.observation.inspection_id + '/location-item-components'
                this.$requests.post('location_item_components', url, location_item_component).then(() => {
                    this.$toast.success('Component toegevoegd')
                })

                this.setup()
            }
        },
        setInspectionId(inspection_id) {
            this.observation.inspection_id = inspection_id;
        },
        setErrorClassification(event) {
            this.observation.error_classification_id = event;
        },
        setRepairPeriod(event) {
            this.observation.repair_period_id = event;
        },
        setRemark(event) {
            this.observation.remark = event
        },
        setImages(uuids) {
            this.image_uuids = uuids
        },
        getLocationItemTypes() {
            this.$requests.get('location_item_types', '/location-item-types').then(location_item_types => {
                this.location_item_types = location_item_types
            });
        },
        cancel() {
            return modalController.dismiss(null, 'cancel');
        },
        async setup() {
            try {
                this.loading = true

                this.location_item_components = await db.location_item_components.toArray()
                this.location_item_component = this.location_item_components.find(location_item_component => location_item_component.uuid == this.observation.location_item_component_uuid)
                this.inspections = await db.inspections.toArray()
                this.refreshLocationItems()


                if (this.$route.query.inspection_id) {
                    this.observation.inspection_id = parseInt(this.$route.query.inspection_id)
                    this.hide_inspection_row = true
                } else {
                    this.observation.inspection_id = this.$store.getters.getInspectionId
                }

                if (this.$route.query.location_item_uuid) {
                    this.current_location_item_uuid = this.$route.query.location_item_uuid
                }

                if (this.$route.query.location_item_component_uuid) {
                    this.observation.location_item_component_uuid = this.$route.query.location_item_component_uuid
                }

                // after 1 second we can set the loading to false
                setTimeout(() => {
                    this.loading = false
                }, 500)
            } catch (error) {
                console.log(error)
            }
        },
        refreshLocationItems() {
            db.inspections.where({ id: this.observation.inspection_id }).first().then(inspection => {
                db.location_items.where({ location_id: inspection.location_id }).toArray().then(location_items => {
                    this.location_items = location_items
                })
            })
        },
        refreshLocationItemComponents() {
            db.location_item_components.where({ location_item_uuid: this.current_location_item_uuid }).toArray().then(location_item_components => {
                this.location_item_components = location_item_components
            })
        },
        validate() {
            if (!this.observation.remark) {
                this.$toast.error('Constatering is verplicht')
                return false
            }
            if (this.observation.remark.length < 5) {
                this.$toast.error('Toelichting moet minstens 5 karakters bevatten')
                return false
            }

            if (this.$store.getters.getInspectionMethodCode == 'IB22') {
                if (this.observation.is_defect) {
                    // if no danger_aspect or error_indication or error_classification or repair_period is set
                    if (!this.observation.danger_aspect_id
                        || !this.observation.error_indication_id
                        || !this.observation.error_classification_id
                        || !this.observation.repair_period_id) {
                        this.$toast.error('Classificatie is verplicht')
                        return false
                    }

                }
            }

            if (!this.observation.location_item_component_uuid) {
                this.$toast.error('Component is verplicht')
                return false
            }

            return true
        },
        async confirm(completed) {
            // Prevent double submission
            if (this.saving) return;

            if (!this.validate()) {
                return
            }

            // Set saving flag to disable buttons
            this.saving = true;

            try {
                if (completed) {
                    this.observation.completed = true
                } else if (!completed) {
                    this.observation.completed = false
                }

                let inspection_id = this.$store.getters.getInspectionId
                let clone_observation = JSON.parse(JSON.stringify(this.observation))

                // created_at
                clone_observation = patch_post_parser(module, clone_observation);
                clone_observation.not_synced = true;

                // add to jobs
                let url = '/inspections/' + inspection_id + '/location-item-components/' + this.observation.location_item_component_uuid + '/observations';
                await this.$requests.post('observations', url, clone_observation)

                await this.createImages()

                // Invalidate component count cache
                this.$store.dispatch('setComponentCountKey');

                this.$router.back()
            } catch (error) {
                console.error('Error saving observation:', error);
                this.saving = false;
                this.$toast.error('Fout bij opslaan');
            }
        },
        async createImages() {
            let images = await db.images.where({ imageable_uuid: this.observation.uuid }).toArray()

            for (let image of images) {
                // Check if there's already a job for this image
                // This prevents duplicate jobs if the image was edited before saving
                const allJobs = await db.jobs.toArray();
                const existingJob = allJobs.find(job => 
                    (job.payload && job.payload.image_uuid === image.uuid) ||
                    (job.payload && job.payload.existing_image_uuid === image.uuid)
                );
                
                if (existingJob) {
                    console.log(`Job already exists for image ${image.uuid} (type: ${existingJob.type}), skipping job creation`);
                    continue;
                }
                
                // Check if image needs compression
                if (!image.compressed) {
                    try {
                        console.log(`Compressing uncompressed image ${image.uuid} before upload`);

                        // Compress the image (1MB target, quality 0.75)
                        const compressedBase64 = await convert.compress(
                            image.base64,
                            1, // maxSizeMB: 1MB (changed from 2MB)
                            1920, // targetWidth: max dimension
                            0.75, // minQuality: JPEG quality (changed from 0.9)
                            false, // addLabel: no label
                            this.$store.getters.checkSetting("crop_to_square"),
                            this.$store.getters.getImageTimestamp,
                            this.$store.getters.getImageInspectorName,
                            this.$store.getters.getUser.name
                        );

                        // Update the image in database with compressed version
                        await db.images.update(image.uuid, {
                            base64: compressedBase64,
                            compressed: true,
                            updated_at: new Date().toISOString()
                        });

                        // Update local reference
                        image.base64 = compressedBase64;
                        image.compressed = true;
                    } catch (error) {
                        console.error(`Failed to compress image ${image.uuid}:`, error);
                        // If compression fails, we'll still upload the original
                        // but log the error for debugging
                    }
                }

                // Use the new S3 upload flow
                const jobUuid = uuid();
                await db.jobs.add({
                    uuid: jobUuid,
                    type: "image-s3-upload",
                    module: "images",
                    url: null,
                    attempt: 0,
                    payload: {
                        uuid: jobUuid,
                        image_uuid: image.uuid,
                        imageable_uuid: this.observation.uuid,
                        entity_type: 'observation'
                    },
                    created_at: new Date().toISOString(),
                });
            }
        },
    },
    computed: {
        getLocationItems() {
            return this.location_items
        },
        getLocationItemComponents() {
            return this.location_item_components
        },
        getErrorIndications() {
            return this.error_indications.filter(error_indication => {
                return error_indication.danger_aspect_id == this.observation.danger_aspect_id
            })
        },
    },
    async beforeRouteLeave(_to, _from, next) {
        // Always allow navigation
        next();
    },
    watch: {
        current_location_item_uuid: {
            handler() {
                this.refreshLocationItemComponents()
            }
        },
        "observation.inspection_id": {
            handler() {
                this.refreshLocationItems()
            }
        }
    }
};
</script>
<style></style>
